import { UserPermission } from '../gql/graphql'
import { useAuthenticatedUser } from './authenticatedUserContext'
import { AuthenticatedUser } from './types'

const hasNetworkPermission = (
  user: AuthenticatedUser,
  permission: keyof typeof UserPermission,
  networkUid: string | null,
): boolean => {
  if (user.allNetworksRole) {
    return user.allNetworksRole.permissions.includes(UserPermission[permission])
  }

  if (!networkUid) {
    return false
  }

  const network = user.networks.find(
    network => network.networkUid === networkUid,
  )

  return network?.role.permissions.includes(UserPermission[permission]) ?? false
}

export const usePermission = () => {
  const user = useAuthenticatedUser()

  return {
    /**
     * ログインユーザーが対象のネットワークで、必要な権限を有するか確認する
     * @param permission チェックする権限
     * @param networkUid ネットワークUID 指定しない場合は全ネットワークでの権限をチェックする
     * @returns boolean
     */
    hasPermission: (
      permission: keyof typeof UserPermission,
      networkUid: string | null,
    ): boolean => {
      return hasNetworkPermission(user, permission, networkUid)
    },
  }
}
